import { render } from "./MerchantWorkbench.vue?vue&type=template&id=4fa84619&scoped=true"
import script from "./MerchantWorkbench.vue?vue&type=script&lang=js"
export * from "./MerchantWorkbench.vue?vue&type=script&lang=js"

import "./MerchantWorkbench.vue?vue&type=style&index=0&id=4fa84619&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa84619"]])

export default __exports__